// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"300e2efa","417":"1d842237","551":"ad48dd62","845":"5407317c","999":"db7ea412"}[chunkId] + ".chunk.js";
};